<template>
  <b-modal
    id="datesForm-modal"
    ref="datesForm-modal"
    :title="
      eventdate && !eventdate.id ? 'Dodaj deadline' : 'Edytuj deadline'
    "
    @hidden="onClose"
    @show="onShow"
  >
    <ValidationObserver
      ref="dateformValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="dateform"
    >
      <ValidationProvider
        name="label"
        rules="required|min:5"
        v-slot="validationContext"
      >
        <b-form-group label="Wydarzenia:" label-for="label">
          <b-form-input
            id="label"
            v-model="form.label"
            placeholder="Wpisz treść wydarzenia..."
            rows="3"
            max-rows="6"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="getValidationState(validationContext)"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </ValidationProvider>
      <b-form-group label="Data wydarzenia:" label-for="date">
        <v-date-picker
          class="datepicker"
          id="date"
          :masks="{ input: 'YYYY-MM-DD' }"
          :columns="$screens({ default: 1, md: 2 })"
          :popover="{ visibility: 'click' }"
          v-model="form.date"
          :min-date="new Date()"
        />
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{ cancel }">
      <b-button
        size="md"
        variant="primary"
        type="submit"
        form="dateform"
        :disabled="isBusy"
        >Zapisz</b-button
      >
      <b-button
        size="md"
        variant="outline-danger"
        @click="cancel()"
        :disabled="isBusy"
        >Anuluj</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ImportantEventsModalForm",
  props: {
    eventdate: { type: Object },
  },
  data() {
    return {
      isBusy: false,
      form: {
        label: "",
        date: "",
      },
    };
  },
  computed: {},
  methods: {
    ...mapActions("construction", [
      "importantEventsAdd",
      "importantEventsUpate",
    ]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      this.form.label = this.eventdate.label || "";
      if (!this.eventdate.date) {
        this.form.date = new Date();
      } else {
        this.form.date = new Date(this.eventdate.date);
      }
    },
    onSubmit() {
      if (this.isBusy === true) return;
      this.$refs.dateformValidation.validate().then((success) => {
        if (!success) {
          return;
        }
        this.isBusy = true;
        this.$Progress.start();
        if (this.eventdate && this.eventdate.label && this.eventdate.date) {
          this.$emit("onUpdate", this.form);
          this.isBusy = false;
        } else {
          this.importantEventsAdd({
            label: this.form.label,
            date: this.form.date,
          })
            .then(() => {
              this.$nextTick(() => {
                this.$bvModal.hide("datesForm-modal");
              });
            })
            .finally(() => {
              this.isBusy = false;
            });
        }
      });
    },
    onClose() {
      this.form.label = "";
      this.form.date = "";
      this.$emit("onClose");
    },
    cancel() {
      this.onClose();
    },
  },
};
</script>
